angular.module('impactx.approval').directive('ixApprovalStatus', function($window) {
    return {
        scope: {
            steps: '=',
            trns: '=',
            status: '=',
            redirectFunction: '&?',
            viewToggle: '=',
            viewInitial: '='
        },
        restrict: 'E',
        templateUrl: 'shared/approval/templates/approval-status.tmpl.html',
        controller: 'ApprovalStatusCtrl',
        controllerAs: 'ctrl',
        link: function(scope) {
            // MNI: removed because vertical view is broken

            // scope.templateUrl = 'shared/approval/templates/approval-status.tmpl.html';
            // $window.onresize = function() {
            //     changeTemplate();
            //     scope.$evalAsync();
            // };
            // changeTemplate();
            //
            // function changeTemplate() {
            //     if(angular.element("#ix-main-view").width() - 300 < 320 * scope.steps.length) {
            //         scope.templateUrl = 'shared/approval/templates/approval-status-vertical.tmpl.html';
            //     }
            //     else {
            //         scope.templateUrl = 'shared/approval/templates/approval-status.tmpl.html';
            //     }
            // }
        }
    }
});
